/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

function Playbook() {
  return (
    <>
    <div className="playbook">
      <div className="playbook__background">
        <div className="playbook__background-left"></div>
        <div className="playbook__background-center"></div>
        <div className="playbook__background-right"></div>
      </div>
      <div className="playbook__grid">
        <div className="playbook__grid-item">
          <div className="playbook__grid-item-image">
            <a href="#">Concept &amp; UX</a>
            <img
              className="lazy"
              data-src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/81/3a/813ac915-900c-4bf4-843e-59d6b6f2d64c/playbook-consulting.svg"
              alt=""
              src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/81/3a/813ac915-900c-4bf4-843e-59d6b6f2d64c/playbook-consulting.svg"
              data-loaded="true"
            ></img>
          </div>
          <h6 className="playbook-small-text">Consulting</h6>
        </div>
        <div className="playbook__grid-item">
          <div className="playbook__grid-item-image">
            <a href="#">Concept &amp; UX</a>
            <img
              className="lazy"
              data-src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/5b/bd/5bbd3d8d-6dcb-4e4d-b399-d73cfe75d643/playbook-concept.svg"
              alt=""
              src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/5b/bd/5bbd3d8d-6dcb-4e4d-b399-d73cfe75d643/playbook-concept.svg"
              data-loaded="true"
            ></img>
          </div>
          <h6 className="playbook-small-text">Concept &amp; UX</h6>
        </div>
        <div className="playbook__grid-item">
          <div className="playbook__grid-item-image">
            <a href="#">Concept &amp; UX</a>
            <img
              className="lazy"
              data-src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/eb/e3/ebe345a9-7d61-494c-8a21-a10a853df918/playbook-design.svg"
              alt=""
              src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/eb/e3/ebe345a9-7d61-494c-8a21-a10a853df918/playbook-design.svg"
              data-loaded="true"
            ></img>
          </div>
          <h6 className="playbook-small-text">Design &amp; Development</h6>
        </div>
        <div className="playbook__grid-item">
          <div className="playbook__grid-item-image">
            <a href="#">Concept &amp; UX</a>
            <img
              className="lazy"
              data-src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/dc/8f/dc8fb6e9-a7fd-4b37-b67a-6915046138d1/playbook-launch.svg"
              alt=""
              src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/dc/8f/dc8fb6e9-a7fd-4b37-b67a-6915046138d1/playbook-launch.svg"
              data-loaded="true"
            ></img>
          </div>
          <h6 className="playbook-small-text">Launch &amp; Operating</h6>
        </div>
        <div className="playbook__grid-item">
          <div className="playbook__grid-item-image">
            <a href="#">Concept &amp; UX</a>
            <img
              className="lazy"
              data-src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/07/c2/07c2184e-3eac-4c87-a674-8b9d5412cfec/playbook-evolve.svg"
              alt=""
              src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/07/c2/07c2184e-3eac-4c87-a674-8b9d5412cfec/playbook-evolve.svg"
              data-loaded="true"
            ></img>
          </div>
          <h6 className="playbook-small-text">Envelope &amp; Support</h6>
        </div>
        <div className="playbook__grid-item">
          <div className="playbook__grid-item-image">
            <a href="#">Concept &amp; UX</a>
            <img
              className="lazy"
              data-src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/8d/d9/8dd9b33d-3aa4-4485-a70a-00d6b96fafed/playbook-development.svg"
              alt=""
              src="https://raditycmswebsite-live-5f5ab2ec57ec4907b-b52c0bb.divio-media.net/filer_public/8d/d9/8dd9b33d-3aa4-4485-a70a-00d6b96fafed/playbook-development.svg"
              data-loaded="true"
            ></img>
          </div>
          <h6 className="playbook-small-text">Development team</h6>
        </div>
      </div>

      <br />

     
    </div>

<div className="section__catchphrase playbook__catchphrase">
I have a playbook to make <span>your digital journey</span> a
success.
<br />
<span>Effective. Successful.</span>
<br />
I want to be a part of your success story.
</div>

</>
  );
}

export default Playbook;
